import { SagaIterator } from 'redux-saga';
import {
  GET_ATTRIBUTES_REQUEST,
  GetAttributesRequestAction,
} from './attributes.types';
import { call, put, takeLatest } from 'redux-saga/effects';
import * as attributesService from '../../services/attributesService/attributesService';

import {
  getAttributesFailure,
  getAttributesSuccess,
} from './attributes.action';
import { IAttributes } from 'types/attributes/attributes.types';

function* getAttributesWorker(
  action: GetAttributesRequestAction
): SagaIterator {
  try {
    const response: IAttributes = yield call(attributesService.getAttributes);
    yield put(getAttributesSuccess(response));
  } catch (error: any) {
    const errorMessage =
      error.response?.data?.message ||
      error.message ||
      'Failed to fetch contacts';
    yield put(getAttributesFailure(errorMessage));
  }
}
export function* attributesSaga(): SagaIterator {
  yield takeLatest(GET_ATTRIBUTES_REQUEST, getAttributesWorker);
}
